//#region imports
import customAxios from '../../utils/customAxios';
import React, { useState, useEffect } from 'react';

import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';

import { IconButton, Tooltip } from '@mui/material';

import { Stack } from '@mui/system';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
} from '@fortawesome/free-solid-svg-icons';

import ModalAsignTech from '../Modal/ModalAsignTech';
import ModalCancelVisit from '../Modal/ModalCancelVisit';
import { useTranslationHook } from '../../hooks/UseTranslationHook';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { GlobalVariables } from '../../globalVar';
import { useTour } from '@reactour/tour';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';

import useVisitsControlTour from '../../tours/visitsControlTour';
import { useTableLocale } from '../../hooks/useTableLocale';

library.add(
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble
);

//#endregion

export const VisitsControl = () => {
  // Config de hooks
  const [dashboardVisitData, setDashboardVisitData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });

  const { t } = useTranslation();

  const {
    tableClientString,
    tableSiteString,
    tableStatusString,
    tableActionsString,
    tableVisitTypeString,
    loadingString,
    visitsFollowStr,
    noVisitsString,
    viewTutorialString,
  } = useTranslationHook();

  const { setIsOpen, setSteps, setCurrentStep } = useTour();

  const visitsControlTour = useVisitsControlTour();

  const locale = useTableLocale();

  useEffect(() => {
    // Check if visitsControlTour has not been viewed
    const hasSeenTour = localStorage.getItem('visitsControlTourViewed');

    if (!hasSeenTour) {
      setIsOpen(true);
      setSteps(visitsControlTour);
      setCurrentStep(0);
      // visitsControlTour viewed
      localStorage.setItem('visitsControlTourViewed', 'true');
    }
  }, [setIsOpen, setSteps]);

  const restartTour = () => {
    setIsOpen(true);
    setSteps(visitsControlTour);
    setCurrentStep(0);
    localStorage.setItem('visitsControlTourViewed', 'false');
  };

  useEffect(() => {
    const updateDashboardVisitData = () => {
      setDashboardVisitData((prevData) => {
        return prevData.map((visit) => ({
          ...visit,
          // vt_name: t(`vtypes.${visit.vt_name}`),
          visit_status_name: t(`vstatuses.${visit.visit_status_name}`),
        }));
      });
    };

    i18next.on('languageChanged', updateDashboardVisitData);

    return () => {
      i18next.off('languageChanged', updateDashboardVisitData);
    };
  }, [t]);

  var userIdForDVisits = localStorage.getItem('userIdForDVisits');

  const endpoint = `${GlobalVariables.getURL()}listVisits/${userIdForDVisits}`;

  const getData = async () => {
    setIsLoading(true);

    try {
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });
      const dashboardVisitData = response.data.visits.map((visit) => {
        return {
          ...visit,
          visit_status_name: t(`vstatuses.${visit.visit_status_name}`),
        };
      });
      setDashboardVisitData(dashboardVisitData);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    // No necesitas hacer nada en este efecto.
  }, [isLoading]);

  const [modalAsignTechShow, setModalAsignTechShow] = useState(false);

  function asignTech(visitInfo) {
    var visitId = visitInfo.id;
    localStorage.setItem('visitIdToAsignTech', visitId);

    var visitClientName = visitInfo.business_name;
    var visitSiteName = visitInfo.site_name;
    var visitTypeName = visitInfo.vt_name;

    localStorage.setItem('visitClientNameForAsign', visitClientName);
    localStorage.setItem('visitSiteNameForAsign', visitSiteName);
    localStorage.setItem('visitTypeNameForAsign', visitTypeName);
  }

  const [modalCancelVisitShow, setModalCancelVisitShow] = useState(false);

  function cancelVisit(visitInfo) {
    var visitId = visitInfo.id;
    localStorage.setItem('visitIdToCancel', visitId);

    var visitClientName = visitInfo.business_name;
    var visitSiteName = visitInfo.site_name;
    var visitTypeName = visitInfo.vt_name;

    localStorage.setItem('visitClientNameForCancel', visitClientName);
    localStorage.setItem('visitSiteNameForCancel', visitSiteName);
    localStorage.setItem('visitTypeNameForCancel', visitTypeName);
  }

  function acknowledgeReject(visitInfo) {
    var visitId = visitInfo.id;

    customAxios
      .patch(
        `${GlobalVariables.getURL()}ackVisit/${visitId}`,
        {},
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        }
      )
      .then(
        (response) => {
          window.location.reload();
          setTimeout(() => {
            console.log('Acknowledge!');
          }, 3600);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  const actionColumn = [
    {
      field: 'action',
      headerName: tableActionsString,
      headerClassName: 'visits-control-actions-tour',
      width: 200,
      renderCell: (params) => {
        if (
          params.row.visit_status_name === 'Servicio cancelado' ||
          params.row.visit_status_name === 'Service cancelled'
        ) {
          return <div className='cellAction'></div>;
        }
        if (
          params.row.visit_status_name === 'Servicio creado' ||
          params.row.visit_status_name === 'Service created'
        ) {
          return (
            <div className='cellAction'>
              <Tooltip title={t('actions.assigntech')} arrow>
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    marginTop: '5px',
                  }}
                  onClick={() => {
                    setModalAsignTechShow(true);
                    asignTech(params.row);
                  }}
                >
                  <FontAwesomeIcon
                    icon={[
                      params.row.prefix,
                      params.row.actionIcon[0].iconName,
                    ]}
                    className='dashboard-visit-progress'
                  />
                </button>
              </Tooltip>
              <Tooltip title={t('actions.cancelvisit')} arrow>
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    marginTop: '5px',
                  }}
                  onClick={() => {
                    setModalCancelVisitShow(true);
                    cancelVisit(params.row);
                  }}
                >
                  <FontAwesomeIcon
                    icon={[
                      params.row.prefix,
                      params.row.actionIcon[1].iconName,
                    ]}
                    className='dashboard-visit-progress'
                  />
                </button>
              </Tooltip>
            </div>
          );
        }
        if (
          params.row.visit_status_name === 'Técnico asignado' ||
          params.row.visit_status_name === 'Assigned technician'
        ) {
          return (
            <div className='cellAction'>
              <Tooltip title={t('actions.cancelvisit')} arrow>
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    marginTop: '5px',
                  }}
                  onClick={() => {
                    setModalCancelVisitShow(true);
                    cancelVisit(params.row);
                  }}
                >
                  <FontAwesomeIcon
                    icon={[
                      params.row.prefix,
                      params.row.actionIcon[0].iconName,
                    ]}
                    className='dashboard-visit-progress'
                  />
                </button>
              </Tooltip>
            </div>
          );
        }
        if (
          params.row.visit_status_name === 'Servicio aceptado por técnico' ||
          params.row.visit_status_name === 'Service accepted by technician'
        ) {
          return (
            <div className='cellAction'>
              <Tooltip title={t('actions.cancelvisit')} arrow>
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    marginTop: '5px',
                  }}
                  onClick={() => {
                    setModalCancelVisitShow(true);
                    cancelVisit(params.row);
                  }}
                >
                  <FontAwesomeIcon
                    icon={[
                      params.row.prefix,
                      params.row.actionIcon[0].iconName,
                    ]}
                    className='dashboard-visit-progress'
                  />
                </button>
              </Tooltip>
            </div>
          );
        }
        if (
          params.row.visit_status_name === 'Servicio rechazado' ||
          params.row.visit_status_name === 'Service rejected'
        ) {
          return (
            <div className='cellAction'>
              <Tooltip title={t('actions.acceptreject')} arrow>
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    marginTop: '5px',
                  }}
                  onClick={() => {
                    acknowledgeReject(params.row);
                  }}
                >
                  <FontAwesomeIcon
                    icon={[
                      params.row.prefix,
                      params.row.actionIcon[0].iconName,
                    ]}
                    className='dashboard-visit-progress'
                  />
                </button>
              </Tooltip>
            </div>
          );
        }
        if (
          params.row.visit_status_name === 'Técnico está trabajando' ||
          params.row.visit_status_name === 'Technician is working'
        ) {
          return (
            <div className='cellAction'>
              <Tooltip title={t('actions.cancelvisit')} arrow>
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    marginTop: '5px',
                  }}
                  onClick={() => {
                    setModalCancelVisitShow(true);
                    cancelVisit(params.row);
                  }}
                >
                  <FontAwesomeIcon
                    icon={[
                      params.row.prefix,
                      params.row.actionIcon[0].iconName,
                    ]}
                    className='dashboard-visit-progress'
                  />
                </button>
              </Tooltip>
            </div>
          );
        }
        if (
          params.row.visit_status_name === 'Técnico ha llegado' ||
          params.row.visit_status_name === 'Technician has arrived'
        ) {
          return (
            <div className='cellAction'>
              <Tooltip title={t('actions.cancelvisit')} arrow>
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    marginTop: '5px',
                  }}
                  onClick={() => {
                    setModalCancelVisitShow(true);
                    cancelVisit(params.row);
                  }}
                >
                  <FontAwesomeIcon
                    icon={[
                      params.row.prefix,
                      params.row.actionIcon[0].iconName,
                    ]}
                    className='dashboard-visit-progress'
                  />
                </button>
              </Tooltip>
            </div>
          );
        } else {
          return <></>;
        }
      },
    },
  ];

  // Columnas
  const dashboardVisitColumns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 60,
    },
    {
      field: 'business_name',
      headerName: tableClientString,
      width: 150,
    },
    {
      field: 'site_name',
      headerName: tableSiteString,
      width: 200,
    },
    {
      field: 'vt_name',
      headerName: tableVisitTypeString,
      width: 200,
    },
    {
      field: 'full_estatus',
      headerName: tableStatusString,
      headerClassName: 'visits-control-status-tour',
      width: 260,
      renderCell: (params) => {
        var estatus = params.row.visit_status_name + ' ';
        return (
          <div>
            <span className='estatus-span'>
              <FontAwesomeIcon
                icon={[params.row.prefix, params.row.iconName]}
                className='dashboard-visit-progress'
              />{' '}
              {estatus}
            </span>
          </div>
        );
      },
    },
    // Map through all columns and add default renderCell if not already defined
  ].map((col) =>
    col.renderCell
      ? col
      : {
          ...col,
          renderCell: (params) =>
            params.row[col.field] ? params.row[col.field] : '-',
        }
  );

  return (
    <>
      <div className='datatable-btns-container'>
        <div className='dt-btn-main-container'>
          <span className='dabiWebText'>{visitsFollowStr} </span>
        </div>
        <Tooltip title={viewTutorialString}>
          <IconButton
            className='tour-button'
            size='medium'
            onClick={() => restartTour()}
          >
            <FontAwesomeIcon icon={faCircleInfo} />
          </IconButton>
        </Tooltip>
      </div>

      <ModalAsignTech
        show={modalAsignTechShow}
        onHide={() => setModalAsignTechShow(false)}
      />

      <ModalCancelVisit
        show={modalCancelVisitShow}
        onHide={() => setModalCancelVisitShow(false)}
      />

      <DataGridPro
        pagination
        loading={isLoading}
        initialState={{
          ...dashboardVisitData.initialState,
          sorting: {
            sortModel: [{ field: 'id', sort: 'desc' }],
          },
          columns: {
            columnVisibilityModel: {
              id: false,
            },
          },
          pinnedColumns: { right: ['action'] },
        }}
        rows={dashboardVisitData}
        columns={dashboardVisitColumns.concat(actionColumn)}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        pageSizeOptions={[5, 10, 25]}
        slots={{
          noRowsOverlay: () => (
            <Stack height='100%' alignItems='center' justifyContent='center'>
              {noVisitsString}
            </Stack>
          ),
          // toolbar: GridToolbar,
        }}
        localeText={locale.components.MuiDataGrid.defaultProps.localeText}
      />
    </>
  );
};
